export default () => {
    const townsList = document.querySelector('.js-TownsList');
    
    if(townsList){
      let allTownsContainer = document.createElement('li');
      allTownsContainer.className = 'CareerList__allTownsContainer CareerList__TownMenu TypoSize-10 js-careerTown';
 
      function getAllTownsContainerText(text) {
        allTownsContainer.innerHTML = text;
        townsList.insertBefore(allTownsContainer, townsList.childNodes[0]);
      }

      if(document.documentElement.lang == 'en-US'){
        let textAllTowns = 'All';
        getAllTownsContainerText(textAllTowns);
      } else {
        let textAllTowns = 'Tutti';
        getAllTownsContainerText(textAllTowns);
      }

    }

    const careerTowns = document.querySelectorAll('.js-careerTown');
    const careerTownsWrapper = document.querySelectorAll('.js-showCareerTown');

    if(careerTowns){
      careerTowns.forEach(town => {
        town.addEventListener('click', () => {
          Array.from(town.parentNode.children).forEach( townMenu => {
            if(townMenu.classList.contains('is-active')){
              townMenu.classList.remove('is-active')
            }
          });

          town.classList.add('is-active'); 

          careerTownsWrapper.forEach(townWrapper => {
            const townName = town.dataset.town;
            const townNameWrapper = townWrapper.dataset.town;

            townWrapper.classList.remove('is-active');

            if(townName == townNameWrapper){
              townWrapper.classList.toggle('is-active');
            }

            if(town.classList.contains('CareerList__allTownsContainer')){
              townWrapper.classList.add('is-active');
            }

          });
        })
      });
    }

}